import React, { useState } from "react";
import { Table } from "antd";
import { computeRowsAndColsForBilling } from "../../utils/functions";
import { UserTransactions } from "pages/users/User";
import useWindowDimensions from "common/functions";

interface ITable {
	data: UserTransactions;
	setNewSort: (value: string) => void;
	offset: number;
	setOffset: (value: number) => void;
	limit: number;
	length: number;
}

const UserTransactionsTable: React.FC<ITable> = ({
	data,
	setNewSort,
	offset,
	setOffset,
	limit,
	length
}) => {

	const [isAsc, setIsAsc] = useState({
		startTime: false,
		endTime: false,
		length: false,
		energy: false,
	});
	const [isDesc, setIsDesc] = useState({
		startTime: false,
		endTime: false,
		length: false,
		energy: false,
	});

	const { width } = useWindowDimensions();

	const { columns, rows } = computeRowsAndColsForBilling(
		data,
		(value) => setNewSort(value), 
		isAsc,
		isDesc,
		(value) => setIsAsc(value),
		(value) => setIsDesc(value),
	);

	return (
		<Table columns={columns} dataSource={rows} size={width > 1600 ? 'large' : (width > 1200 ? 'middle' : 'small')}
			scroll={{ x: 500 }}
			pagination={{
				total: length,
				current: offset + 1,
				onChange: (page) => setOffset(page - 1),
				defaultPageSize: limit,
				showSizeChanger: false
			}}
			bordered />
	);
};

export default UserTransactionsTable;
